import { motion } from "framer-motion";
import { Button } from "./ui/button";
import { LucideIcon, ArrowRight, Check } from "lucide-react";

interface AcneServiceCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  features: string[];
  onBookNow: () => void;
}

export function AcneServiceCard({ 
  icon: Icon, 
  title, 
  description, 
  features, 
  onBookNow 
}: AcneServiceCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="group bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-[#d4a574]/30 relative overflow-hidden h-full flex flex-col"
    >
      <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-to-br from-[#d4a574]/10 to-transparent rounded-full -mr-20 -mt-20 group-hover:scale-150 transition-transform duration-700"></div>
      
      <div className="relative z-10 flex-1 flex flex-col">
        <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#f9f1e8] to-[#faf8f5] rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300 shadow-md">
          <Icon className="w-8 h-8 text-[#d4a574]" />
        </div>
        
        <h3 className="text-[#2c2c2c] mb-3 group-hover:text-[#d4a574] transition-colors">{title}</h3>
        <p className="text-[#666] leading-relaxed mb-6 text-sm">{description}</p>
        
        <ul className="space-y-3 mb-8 flex-1">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start text-[#666] text-sm">
              <div className="w-5 h-5 rounded-full bg-[#d4a574]/10 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                <Check className="w-3 h-3 text-[#d4a574]" />
              </div>
              <span>{feature}</span>
            </li>
          ))}
        </ul>
        
        <Button
          onClick={onBookNow}
          className="w-full bg-gradient-to-r from-[#d4a574] to-[#c89464] hover:from-[#c89464] hover:to-[#b8845a] text-white rounded-full transition-all duration-300 shadow-lg shadow-[#d4a574]/30 group/btn"
        >
          Book Now
          <ArrowRight className="w-4 h-4 ml-2 group-hover/btn:translate-x-1 transition-transform" />
        </Button>
      </div>
    </motion.div>
  );
}
